import React from 'react';
import { Dialog, DialogContent, DialogActions, Typography, Stack, Button, Box } from '@mui/material';
import Icon from '@/units/Icon';
import { User } from '@/_models/User';
import { toast } from 'react-toastify';

interface CompleteNoteModalProps {
  selectedNote: any;
  foundUser: User;
  isCompletionModalOpen: boolean;
  handleClose: () => void;
  completeNote: (noteId: number) => void;
}

export const CompleteNoteModal: React.FC<CompleteNoteModalProps> = ({ selectedNote, foundUser, isCompletionModalOpen, handleClose, completeNote }) => {
  const handleConfirm = async (e) => {
    e.stopPropagation();
    if (foundUser.id !== selectedNote.userId) {
      toast.error('Only user, who creted this Note can mark it as complete');
      handleClose();
      return;
    }
    await completeNote(selectedNote.id);
    handleClose();
  };

  return (
    <Dialog
      open={isCompletionModalOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-paper': { background: 'transparent', borderRadius: '12px' },
      }}
    >
      <Stack sx={{ maxWidth: '400px', background: 'white', borderRadius: '12px' }}>
        <DialogContent>
          <Box display="flex" alignItems="start" justifyContent="flex-start" paddingBottom={2}>
            <Icon.Attention style={{fontSize: 40 }} />
          </Box>
          <Typography variant="h6" align="left" gutterBottom>
            Mark as completed?
          </Typography>
          <Typography variant="body2" align="left" color="textSecondary">
            Are you sure you want to mark this note as completed? You can find and restore the note from archive later.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" spacing={2} justifyContent="center" width="100%" padding={2}>
            <Button variant="outlined" onClick={handleClose} style={{ width: 120 }}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleConfirm} color="primary" style={{ width: 120 }}>
              Confirm
            </Button>
          </Stack>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};
